import { ISchema } from '@formily/react'
import { ClickEventSetter, ClickCustomEventSetter } from '../../../Formily/src/setters'

export const NavBar: ISchema = {
  type: 'object',
  properties: {
    children: {
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'Input',
    },
    backArrow: {
      title: '返回箭头',
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'Switch',
      "x-component-props": {
        defaultChecked: true
      }
    },
    back: {
      title: '返回区域文字',
      type: 'string',
      'x-decorator': 'FormItem',
      'x-component': 'Input',
      'x-reactions': [
        {
          dependencies: ['.backArrow'],
          fulfill: {
            state: {
              visible: '{{$deps[0]}}'
            }
          }
        }
      ]
    },
    'clickEventProps': {
      title: '返回箭头事件',
      type: 'Object',
      'x-decorator': 'FormItem',
      'x-component': ClickEventSetter,
      "x-component-props": {
        senceType: 'modal'
      },
      'x-reactions': [
        {
          dependencies: ['.backArrow'],
          fulfill: {
            state: {
              visible: '{{$deps[0]}}'
            }
          }
        }
      ]
    },
    clickCustomEventProps: {
      title: '返回箭头能力',
      type: 'Object',
      'x-decorator': 'FormItem',
      'x-component': ClickCustomEventSetter,
      "x-reactions": [
        {
          dependencies: [".backArrow"],
          fulfill: {
            state: {
              visible: "{{$deps[0]}}",
            },
          },
        },
      ],
    },
  },
}

